import * as React from "react";
import { func } from "../../../../utils";
import useWindowSize from "../../../../hooks/useWindowSize";

import { Wrapper, Container } from "./TimelineSoc.styled";
import SocTimeline from "../../../atoms/SocTimeline";
import Show from "../../../atoms/Show/Show";
import { useFetchTimelineSoc } from "../../../../networks";
import moment from "moment";

export interface TimelineSocProps {
  regionId?: number;
}

const TimelineSoc: React.FC<TimelineSocProps> = ({ regionId }) => {
  const { size } = useWindowSize();
  // @ts-ignore
  const isMobileView = (size?.width || 0) <= 830;

  const currentYear = new Date()?.getFullYear();

  const socSlug = currentYear === 2025 ? "soc-2025" : "soc";

  const { data: dataTimelineSocRaw, isFetching } = useFetchTimelineSoc(socSlug);

  const dataTimelineSoc = dataTimelineSocRaw?.data?.data?.timeline ?? [];

  const dataTimelineWithTitle = React.useMemo(() => {
    return Object.keys(dataTimelineSoc)?.map((key, idx) => ({
      day: `Day ${idx + 1}`,
      date: moment(key)?.format("LL"),
      timeline: dataTimelineSoc?.[key],
    }));
  }, [dataTimelineSoc]);

  const getBackgroundImage = React.useCallback(() => {
    if (isMobileView) return func.getStaticImg("illustration/timeline-background-m.png");

    return func.getStaticImg("illustration/timeline-background.png");
  }, [isMobileView]);

  const backgroundImage = getBackgroundImage();

  if (isFetching) return null;

  return (
    <div className="relative">
      {/* @ts-ignore */}
      <Wrapper
        id="timeline-soc"
        // @ts-ignore
        backgroundImage={backgroundImage}
        height={isMobileView ? "100%" : "100vh"}
      >
        <Show when={isMobileView}>
          <div className="mt-[100px] pt-2 pb-[20vh] px-[16px]">
            <h1 className="text-[20px] font-semibold text-white title-text">Timeline</h1>
            <SocTimeline data={dataTimelineWithTitle} mode={"mobile"} />
          </div>
        </Show>

        <Show when={!isMobileView}>
          <div className="m-auto w-[1136px] relative top-[-100px]">
            <h1 className="text-[28px] font-semibold text-white title-text">Timeline</h1>
            <SocTimeline data={dataTimelineWithTitle} mode={"desktop"} />
          </div>
        </Show>
      </Wrapper>
    </div>
  );
};

export default TimelineSoc;
